import { PreferenceStoreIdentifier } from '@transcend-io/privacy-types';

import { DecryptResponse } from '@main/sm-browser';
import {
  DecryptedConsentIdentifiersResponse,
  DecryptionContext,
} from '@main/sombra-types';

/**
 * Decrypts the consent identifiers from the Diffie Hellman response
 *
 * @param decryptDhResponse -  A function that can be used to decrypt a DecryptionContext for that request.
 * @param decryptionContext - The decryption context to decrypt
 * @param encryptedIdentifiers - The encrypted consent identifiers from the response
 * @returns The decrypted consent identifiers
 */
export function decryptConsentIdentifiers(
  decryptDhResponse: DecryptResponse,
  decryptionContext: DecryptionContext,
  encryptedIdentifiers: PreferenceStoreIdentifier[],
): PreferenceStoreIdentifier[] {
  const { decryptedMapping } = JSON.parse(
    decryptDhResponse(decryptionContext).toString('utf-8'),
  ) as DecryptedConsentIdentifiersResponse;

  return encryptedIdentifiers.map(({ name, value }) => ({
    name,
    value: decryptedMapping[value],
  }));
}
